export default __webpack_public_path__ + "static/media/btc_logo.8b45bfc7.svg";